import { render } from "./ClimateRiskTab.vue?vue&type=template&id=f1ee04d8&scoped=true"
import script from "./ClimateRiskTab.vue?vue&type=script&lang=js"
export * from "./ClimateRiskTab.vue?vue&type=script&lang=js"

import "./ClimateRiskTab.vue?vue&type=style&index=0&id=f1ee04d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ee04d8"]])

export default __exports__